import {Component, useState} from "react";
import { ChevronDownIcon } from '@heroicons/react/16/solid'
import submitForm from "../../models/forms";


export default function FreeMonthForm() {

    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [website, setWebsite] = useState("");
    const [phoneNumber, setPhoneNUmber] = useState("");

    const [didSubmit, setDidSubmit] = useState(false);

    return (
        <div>
            <div id="bottom-form">
                <div className="container flex items-center justify-center">
                    <div className="embed">
                        <div style={{width: '100%'}}>
                            <div className="pb-12 pt-8">
                                <h2 className="text-base/7 font-semibold text-white">
                                    <div className="custom-font">WIN A FREE MONTH</div>
                                </h2>
                                <div className="mt-1 text-gray-300 custom-font font-light">
                                    Visibility on Google is powerful, but expert guidance can be expensive.
                                    At HerStory, we believe every brand deserves a chance to be found.
                                    We're on a mission to democratize growth by offering free SEO services to brands
                                    that need it most. Since launching this program in 2021, we've helped over 130 brands find their audience.
                                    Now, it's your turn. Win a free month of our expert SEO service.
                                    We’ll guide you through what you’re missing and help you get the visibility you need
                                    on Google.
                                </div>

                                <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                                    <div className="sm:col-span-3">
                                        <label htmlFor="first-name" className="block text-sm/6 font-medium text-white">
                                            Full name
                                        </label>
                                        <div className="mt-2">
                                            <input
                                                id="full-name"
                                                name="full-name"
                                                type="text"
                                                autoComplete="name"
                                                disabled={didSubmit}
                                                value={fullName}
                                                onChange={(e) => {setFullName(e.target.value)}}
                                                className="block w-full rounded-md bg-white/5 px-3 py-1.5 text-base text-white outline outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-500 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 sm:text-sm/6"
                                            />
                                        </div>
                                    </div>

                                    <div className="sm:col-span-3">
                                        <label htmlFor="email" className="block text-sm/6 font-medium text-white">
                                            Email address
                                        </label>
                                        <div className="mt-2">
                                            <input
                                                id="email"
                                                name="email"
                                                type="email"
                                                autoComplete="email"
                                                disabled={didSubmit}
                                                value={email}
                                                onChange={(e) => {setEmail(e.target.value)}}
                                                className="block w-full rounded-md bg-white/5 px-3 py-1.5 text-base text-white outline outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-500 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 sm:text-sm/6"
                                            />
                                        </div>
                                    </div>

                                    <div className="sm:col-span-2 sm:col-start-1">
                                        <label htmlFor="city" className="block text-sm/6 font-medium text-white">
                                            Website
                                        </label>
                                        <div className="mt-2">
                                            <input
                                                id="website"
                                                name="website"
                                                type="url"
                                                disabled={didSubmit}
                                                value={website}
                                                onChange={(e) => {setWebsite(e.target.value)}}
                                                className="block w-full rounded-md bg-white/5 px-3 py-1.5 text-base text-white outline outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-500 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 sm:text-sm/6"
                                            />
                                        </div>
                                    </div>

                                    <div className="sm:col-span-2">
                                        <label htmlFor="region" className="block text-sm/6 font-medium text-white">
                                            Phone number
                                        </label>
                                        <div className="mt-2">
                                            <input
                                                id="tel"
                                                name="tel"
                                                type="tel"
                                                autoComplete="tel"
                                                disabled={didSubmit}
                                                value={phoneNumber}
                                                onChange={(e) => {setPhoneNUmber(e.target.value)}}
                                                className="block w-full rounded-md bg-white/5 px-3 py-1.5 text-base text-white outline outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-500 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 sm:text-sm/6"
                                            />
                                        </div>
                                    </div>

                                    {/*<div className="sm:col-span-2">*/}
                                    {/*    <label htmlFor="postal-code" className="block text-sm/6 font-medium text-white">*/}
                                    {/*        ZIP / Postal code*/}
                                    {/*    </label>*/}
                                    {/*    <div className="mt-2">*/}
                                    {/*        <input*/}
                                    {/*            id="postal-code"*/}
                                    {/*            name="postal-code"*/}
                                    {/*            type="text"*/}
                                    {/*            autoComplete="postal-code"*/}
                                    {/*            className="block w-full rounded-md bg-white/5 px-3 py-1.5 text-base text-white outline outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-500 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 sm:text-sm/6"*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}


                                </div>

                                <div className="justify-end mt-8 flex items-end gap-x-6">

                                    <div className="flex justify-end">
                                        <button
                                            type="button"
                                            disabled={didSubmit}
                                            className={`${didSubmit ? "bg-gray-600" : "bg-red-600 hover:bg-indigo-500"} mt-4 w-full rounded-full px-4 py-2.5 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
                                            onClick={() => {
                                                submitForm("win_free_month", {
                                                    full_name: fullName,
                                                    email: email,
                                                    website: website,
                                                    phone_number: phoneNumber
                                                })
                                                setDidSubmit(true)
                                            }}
                                        >
                                            { didSubmit ? "Submitted!" : "Submit Free Entry" }
                                        </button>
                                    </div>
                                    <a href="/contact-us" target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-white">
                                        Contact Us{" "}
                                        <span aria-hidden="true">&rarr;</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}